__turbopack_context__.v({
  "accordion": "Ilg35q_accordion",
  "apply-filters": "Ilg35q_apply-filters",
  "btn": "Ilg35q_btn",
  "filter-body": "Ilg35q_filter-body",
  "filter-div": "Ilg35q_filter-div",
  "filter-head": "Ilg35q_filter-head",
  "filter-mob": "Ilg35q_filter-mob",
  "filter-mob-close": "Ilg35q_filter-mob-close",
  "filter-name": "Ilg35q_filter-name",
  "filter-overlay": "Ilg35q_filter-overlay",
  "filter-wrapper": "Ilg35q_filter-wrapper",
  "filtered-by": "Ilg35q_filtered-by",
  "layered-navigations": "Ilg35q_layered-navigations",
  "line-header": "Ilg35q_line-header",
  "open": "Ilg35q_open",
});
